import React, { useCallback, useState } from 'react';
import { pointer } from 'd3-selection';

import classNames from 'classnames';

const MouseoverDetection = ({
  x,
  y,
  width,
  height,
  onClick = () => {},
  onMouseHover = () => {},
  hidePointer = false,
}) => {
  const [isHovered, setHovered] = useState(false);
  const handleMouseEnter = useCallback(() => {
    setHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHovered(false);
    onMouseHover(null);
  }, [onMouseHover])

  const handleMouseOver = useCallback((e) => {
    const mousePosition = pointer(e);

    if (isHovered) {
      onMouseHover(mousePosition);
    }
  }, [isHovered, onMouseHover])

  const handleMouseClick = useCallback((e) => {
    const mousePosition = pointer(e);

    if (isHovered) {
      onClick(mousePosition);
    }
  }, [isHovered, onClick])

  return (
    <rect
      className={classNames(
        'mouseover-detection z-10',
        { 'cursor-pointer': !hidePointer },
      )}
      fill="white"
      opacity={0}
      x={x}
      y={y}
      height={height}
      width={width}
      onClick={handleMouseClick}
      onMouseOver={handleMouseEnter}
      onMouseMove={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    />
  )
}

export default MouseoverDetection;
